export const WEB_TRACER_VERSION = "1.0.0";

export const ROOT_SPAN_NAME = "View";

export const ONE_MINUTE_MS = 60000;

export const DEFAULT_SCHEDULED_DELAY_MILLIS = 10 * ONE_MINUTE_MS;

export const DEFAULT_FLUSH_INTERVAL = 30000; // 30 seconds

export { version as PACKAGE_VERSION } from "../package.json";
